import React from 'react'
import Zoom from 'react-reveal/Zoom'

import {
  SectionContainer,
  SectionTitle,
  SectionText,
  SectionIcon,
} from '../../_common'

import { RiStarSmileFill, RiEyeLine } from 'react-icons/ri'
import { FaHandHoldingHeart, FaLock } from 'react-icons/fa'

import { lightTheme } from '../../../App.theme'
import { Grid, Typography } from '@material-ui/core'

import useStyles from './styles'

const Values = () => {
  const { titleClass } = useStyles()

  const values = [
    {
      icon: <RiStarSmileFill />,
      iconColor: lightTheme.palette.text.white,
      color: lightTheme.palette.extras.green,
      title: 'Compromiso',
      text:
        'Para conseguir establecer relaciones a largo plazo, se debe de cumplir en todo momento con los acuerdos alcanzados, a fin de generar y mantener la confianza de los clientes y aliados estratégicos de Global Actuarial Services.',
    },

    {
      icon: <FaHandHoldingHeart />,
      iconColor: lightTheme.palette.text.white,
      color: lightTheme.palette.extras.orange,
      title: 'Confianza',
      text:
        'Otorgando una consultoría de calidad y cuidando en todo momento la información clave, ya que derivada de ella se tiene un impacto contable y financiero importante para nuestros clientes y aliados, consolidándose para generar aliados confiables.',
    },

    {
      icon: <FaLock />,
      iconColor: lightTheme.palette.text.white,
      color: lightTheme.palette.extras.purple,
      title: 'Respeto',
      text:
        'Con un trato adecuado y respetando el manejo responsable de datos e información clave, cuidando y anteponiendo siempre en todo momento los intereses de los clientes y una operación sustentada en la ética y la honestidad.',
    },

    {
      icon: <RiEyeLine />,
      iconColor: lightTheme.palette.text.white,
      color: lightTheme.palette.extras.indigo,
      title: 'Transparencia',
      text:
        'Manteniendo siempre un trato adecuado y respetando el manejo responsable de datos e información clave, cuidando y anteponiendo en todo momento los intereses de los clientes y una operación sustentada en la ética y la honestidad.',
    },
  ]

  return (
    <SectionContainer sectionID="values">
      <SectionTitle centered title="Valores" />

      <Zoom>
        {values.map(({ title, icon, iconColor, color, text }, i) => (
          <Grid key={i} container>
            <SectionIcon {...{ icon, iconColor, color }} />
            <Typography className={titleClass}>{title}</Typography>
            <SectionText {...{ text }} />
          </Grid>
        ))}
      </Zoom>
    </SectionContainer>
  )
}

export default Values
